const SupportingFuncs = {
  /**
   * Function to get the project ID from a URL
   * @param {string} url - The URL to extract the project ID from, like this "https://developer.api.autodesk.com/data/v1/projects/b.b887cdac-9dbe-4a40-90e3-be3853cbbb1b/items/urn:adsk.wipprod:dm.lineage:IoyazEvOQhGxftjvlPXptA"
   * @returns {string} - The extracted project ID.
   * @throws {Error} - If the project ID is not found in the URL.
   */
  projectIDFromURL: function (url) {
    const match = url.match(/\/projects\/(b\.[^\/]+)/);
    if (match) {
      const projectId = match[1];
      return projectId;
    }
    throw new Error("Project ID not found in folder data");
  },

  downloadCSV: (csv, filename = "data.csv") => {
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
};

export default SupportingFuncs;
